/**
 * Librería de codigos de Tiendas
 */
export enum store {
  DEFAULT = 1,
}
